import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { HeaderNavigation, IconSidebar } from "./layouts";

// Route Views
import UserProfile from "./views/UserProfile";
import UserProfileLite from "./views/UserProfileLite";
import EditUserProfile from "./views/EditUserProfile";
import Login from "./views/Login";
import Register from "./views/Register";
import ForgotPassword from "./views/ForgotPassword";
import ResetPassword from "./views/ResetPassword";
import ChangePassword from "./views/ChangePassword";
import Errors from "./views/Errors";
import Forbidden from "./views/Forbidden";
import TokenExpired from "./views/TokenExpired";

import Blank from "./views/Blank";

import Home from "./views/Home";
import PendingVouchersView from "./views/PendingVouchers";
import NewVoucherView from "./views/NewVoucher";
import ProccssedView from "./views/ProccessedView";

const BlankIconSidebarLayout = ({ children }) => (
  <IconSidebar noNavbar noFooter>
    {children}
  </IconSidebar>
);

export default [
  {
    path: "/",
    exact: true,
    layout: HeaderNavigation,
    component: () => <Redirect to="/login" />
  },
  {
    path: "/home",
    exact: true,
    layout: HeaderNavigation,
    component: Home,
    private: false,
    roles: ["super-admin"]
  },
  {
    path: "/login",
    layout: BlankIconSidebarLayout,
    component: Login,
    private: false
  },
  {
    path: "/register",
    layout: BlankIconSidebarLayout,
    component: Register
  },
  {
    path: "/forgot-password",
    layout: BlankIconSidebarLayout,
    component: ForgotPassword
  },
  {
    path: "/reset-password",
    layout: BlankIconSidebarLayout,
    component: ResetPassword
  },
  {
    path: "/change-password",
    layout: BlankIconSidebarLayout,
    component: ChangePassword
  },
  {
    path: "/pending",
    layout: HeaderNavigation,
    component: PendingVouchersView
  },
  {
    path: "/proccessed",
    layout: HeaderNavigation,
    component: ProccssedView
  },
  {
    path: "/new-voucher/:id",
    layout: HeaderNavigation,
    component: NewVoucherView,
    exact: true,
    private: false
  },
  {
    path: "/notFound",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: Errors
  },
  {
    path: "/token-expired",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: TokenExpired
  },
  {
    path: "/forbidden",
    exact: false,
    layout: BlankIconSidebarLayout,
    component: Forbidden
  },
  {
    path: "/*",
    exact: false,
    layout: HeaderNavigation,
    component: () => <Redirect to="/notFound" />
  }
];
